import { Box, Button, Typography } from "@mui/material";
function LinksPage() {
  const links = [
    {
      title: 'LinkedIn',
      description: 'Connect on LinkedIn',
      url: 'https://linkedin.com/in/thirupathi-thangavel',
      icon: 'https://img.icons8.com/?size=100&id=13930&format=png&color=000000'
    },
    {
      title: 'GitHub',
      description: 'Check out my projects',
      url: 'https://github.com/t-thirupathi',
      icon: 'https://img.icons8.com/?size=100&id=12599&format=png&color=FFFFFF'
    },
    {
      title: 'Email',
      description: 'thirupathi.thangavel@gmail.com',
      url: 'mailto:thirupathi.thangavel@gmail.com',
      icon: 'https://img.icons8.com/?size=100&id=P7UIlhbpWzZm&format=png&color=000000'
    }, 
    {
      title: 'Stack Overflow',
      description: 'View my Stack Overflow profile',
      url: 'https://stackoverflow.com/users/3273991/thirupathi-thangavel',
      icon: 'https://img.icons8.com/?size=100&id=xpLsvIw1xpqQ&format=png&color=000000'
    }
  ];

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto' }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ mb: 4 }}>
        Connect with me
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {links.map((link, index) => (
          <Button
            key={index}
            variant="outlined"
            href={link.url}
            
            target={link.url.startsWith('http') ? '_blank' : undefined}
            rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
            sx={{
              p: 2,
              justifyContent: 'flex-start',
              textAlign: 'left',
              textTransform: 'none'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
              <img src={link.icon} alt={link.title} width="32" height="32" />
              <Box>
                <Typography variant="h6" component="div">
                  {link.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {link.description}
                </Typography>
              </Box>
            </Box>
          </Button>
        ))}
      </Box>
    </Box>
  );
}

export default LinksPage;